/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './checkHandleAvailability.defs.js'
export * as $defs from './checkHandleAvailability.defs.js'
